import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../redux/LoginHistoryAndWorkHours/actions';
import TableSearch from '../../common/TableSearch';
import Preloader from '../../layouts/Preloader';
import Breadcrumb from './Breadcrumb';
import moment from 'moment';
import ReactPagination from '../../common/React-Pagination';

export default function Content(props) {

    const { Page } = props;

    const dispatch = useDispatch();

    const [search, setsearch] = useState('');
    const [fetchSuccess, setFetchSuccess] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [postsPerPage, setPostPerPage] = useState(10);
    const [buttonChange, setButtonChange] = useState(false);

    let [startDate, setStartDate] = useState(moment().format('DD-MM-YYYY'));

    const { Inactive_Vendors } = useSelector(state => state.LoginHistoryAndWorkHoursReducer);

    useEffect(() => {
        dispatch({
            type: actions.GET_INACTIVE_VENDORS_LIST,
            payload: moment().format('DD-MM-YYYY')
        });
        //eslint-disable-next-line
    }, []);

    const handleSearchbar = (e) => {
        setsearch(e.target.value.toLowerCase());
        setCurrentPage(0);
    };

    useEffect(() => {
        if (Inactive_Vendors?.message === 'No Records Found') {
            setFilteredData([]);
        } else {
            setFilteredData(Inactive_Vendors.filter(val => {
                if (search === '') {
                    return val;
                } else if ((val.Vendor_ID && val.Vendor_ID.toLowerCase().includes(search)) ||
                    (val.VendorName && val.VendorName.toLowerCase().includes(search)) ||
                    (val.LastLogin_At && val.LastLogin_At.toLowerCase().includes(search)) ||
                    (val.LastLogout_At && val.LastLogout_At.toLowerCase().includes(search)) ||
                    (val.DayDifference && `${val.DayDifference?.toString() + 'days ago'}`?.includes(search))
                ) {
                    return val;
                } else {
                    return null;
                }
            }))
        };
    }, [Inactive_Vendors, search]);

    const indexOfFirstPost = (currentPage * postsPerPage) % filteredData?.length;
    const indexOfLastPost = indexOfFirstPost + postsPerPage;
    const currentdata = filteredData.slice(indexOfFirstPost, indexOfLastPost);

    // Change page
    const paginate = (event) => {
        setCurrentPage(event.selected);
    };

    const handleShowPerPage = (e) => {
        setPostPerPage(parseInt(e.target.value));
        setCurrentPage(0);
    };

    const handleSelectedDateRange = (e) => {
        setStartDate(startDate = e.target.value);
    };

    const handleFilterDateRange = (e) => {
        e.preventDefault();
        if (buttonChange) {
            setStartDate('');
            setButtonChange(false);
            dispatch({
                type: actions.GET_INACTIVE_VENDORS_LIST,
                payload: moment().format('DD-MM-YYYY')
            });
        } else {
            if (startDate) {
                setButtonChange(true);
                dispatch({
                    type: actions.GET_INACTIVE_VENDORS_LIST,
                    payload: moment(startDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
                });
            };
        };
    };

    const handlePageRefresh = (e) => {
        e.preventDefault();
        if (startDate) {
            dispatch({
                type: actions.GET_INACTIVE_VENDORS_LIST,
                payload: moment(startDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
            });
        } else {
            dispatch({
                type: actions.GET_INACTIVE_VENDORS_LIST,
                payload: moment().format('DD-MM-YYYY')
            });
        }
    };

    useEffect(() => {
        (Inactive_Vendors.length === 0) ? setFetchSuccess(false) : setFetchSuccess(true);
    }, [Inactive_Vendors]);

    return (
        <>
            {!fetchSuccess ?
                <Preloader fetchSuccess={fetchSuccess} /> :
                <div className="ms-content-wrapper">
                    <div className="row">
                        <div className="col-md-12">
                            <Breadcrumb Page={Page} handlePageRefresh={handlePageRefresh} />
                            <div className="ms-panel">
                                <div className="ms-panel-header">
                                    <Row>
                                        <Col xl={5} lg={12} md={12} sm={12}>
                                            <h6>Inactive Vendor</h6>
                                        </Col>
                                        <Col xl={7} lg={12} md={12} sm={12} className='d-flex justify-content-end'>
                                            <Row>
                                                <Col xl={1} lg={1} md={1} sm={1}></Col>
                                                <Col xl={6} lg={6} md={6} sm={6}>
                                                    <input
                                                        type='date'
                                                        className='form-control ml-3'
                                                        max={moment().format('YYYY-MM-DD')}
                                                        value={startDate || ""}
                                                        disabled={buttonChange}
                                                        onChange={(e) => handleSelectedDateRange(e)}
                                                    />
                                                </Col>
                                                <Col xl={3} lg={3} md={3} sm={3}>
                                                    <Button
                                                        size='sm'
                                                        variant={buttonChange ? 'danger' : 'success'}
                                                        disabled={(startDate) ? false : true}
                                                        className={(startDate) ? 'form-control font-weight-bold' : 'form-control font-weight-bold cursor-notallowed'}
                                                        onClick={handleFilterDateRange}
                                                    >
                                                        {buttonChange ? 'Clear' : 'Filter'}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="ms-panel-body tabledata-background">
                                    <div className="table-responsive Scrollbar-Style">
                                        <div id="data-table-5_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" id="data-table-5_length">
                                                        <label>
                                                            Show
                                                            <select name="data-table-5_length" aria-controls="data-table-5" className="custom-select custom-select-sm form-control form-control-sm" onChange={handleShowPerPage}>
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                            </select> entries
                                                        </label>
                                                    </div>
                                                </div>
                                                <TableSearch
                                                    label='Search'
                                                    type="search"
                                                    placeholder="search Id/Status..."
                                                    onChange={handleSearchbar}
                                                />
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <table id="data-table-5" className="table w-100 thead-primary dataTable no-footer" role="grid" aria-describedby="data-table-5_info" >
                                                        <thead>
                                                            <tr role="row">
                                                                <th scope="col">Vendor ID</th>
                                                                <th scope="col">Vendor Name</th>
                                                                <th scope="col">Clock In At</th>
                                                                <th scope="col">Clock Out At</th>
                                                                <th scope="col">Last Active</th>
                                                            </tr>
                                                        </thead>
                                                        {filteredData.length > 0 ?
                                                            <tbody>
                                                                {currentdata.map((val, i) =>
                                                                    <tr className="odd" key={i}>
                                                                        <th className='id-column' scope="row">{val.Vendor_ID}</th>
                                                                        <td>{val.VendorName}</td>
                                                                        <td>{val.LastLogin_At ?? '-'}</td>
                                                                        <td>{val.LastLogout_At ?? '-'}</td>
                                                                        <td>{!val.DayDifference ? '-' : val.DayDifference === 1 ? '1 day ago' : val.DayDifference + ' days ago'}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody> :
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={5} className='font-weight-bold'>No Records Found</td>
                                                                </tr>
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {filteredData.length > postsPerPage &&
                                        <ReactPagination
                                            paginate={paginate}
                                            pageCount={Math.ceil(filteredData?.length / postsPerPage)}
                                            currentPage={currentPage}
                                            currentdata={currentdata}
                                            totalPosts={filteredData.length}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
};